export default {
  autocomplete: {},
  checkbox: {
    marginRight: 8,
  },
}
